<template lang="pug">
  .shop.page
</template>

<script lang="js">

export default {
  name: 'ShopPage',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.shop {

}
</style>
